// DonutChart.js
import React from "react";
import { Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Border } from "@syncfusion/ej2-react-circulargauge";

ChartJS.register(ArcElement, Tooltip, Legend);

// Custom plugin to support individual arc widths
const customArcWidthPlugin = {
  id: 'customArcWidthPlugin',
  beforeDraw(chart) {
    const { config } = chart;
    const meta = chart.getDatasetMeta(0);
    const arcWidths = config.options.customArcWidths || [];

    meta.data.forEach((arc, index) => {
      const thickness = arcWidths[index] || 30;
      arc.outerRadius = arc.innerRadius + thickness;
    });
  },
};

ChartJS.register(customArcWidthPlugin);

const LiveConversion = () => {
  const data = {
    labels: ["Page 1", "Page 3", "Page 2", "Other Page"],
    datasets: [
      {
        data: [50, 35, 25, 10],
        backgroundColor: ["#728CC7", "#AC4390", "#CF86BB", "#52279B"],
        Border: "1px",
        borderWidth: 1,
        borderRadius: "5px",
      },
    ],
  };

  const options = {
  cutout: "25%",
  customArcWidths: [90, 60, 90, 80],
  plugins: {
    legend: {
      position: "bottom",
      labels: {
        usePointStyle: true,
        pointStyle: "circle",
        padding: 20,
        font: {
          size: 14,
          weight: "500"
        },
        color: "#333",
      },
    },
     tooltip: {
      enabled: true, // ❌ Turn off tooltip if you also don't want hover values
    },
    datalabels: {
      display: false, // ⛔ Explicitly disable data labels if plugin is registered
    },
  },
  responsive: true,
  maintainAspectRatio: false,
};


  return (
    <div className="black-chart-container">
      <Doughnut data={data} options={options} />
    </div>
  );
};

export default LiveConversion;
